import Vue from 'vue';
import mixin from "../../mixins/mixin";
import rentalService from "../../services/rental";

var clipboard = '';

export default {
  data() {
    return {
      selected_lock: "",
      lockingInProcces: false,
      lock_types: [],
    };
  },
  props: {
    rental: Object,
    booking: Object,
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue')
  },
  mixins:[mixin],
  async mounted() {
    let vm = this;


    if (clipboard) {
      clipboard.destroy();
    }

    clipboard = new Clipboard('.copy-open-or-close-link');
    clipboard.on('success', function(e) {
      toastr.success(vm.$t("rentals.detail.copied"));
      e.clearSelection();
    });

    clipboard.on('error', function(e) {
      toastr.error(vm.$t("rentals.detail.not_copied"));
    });

  },
  methods: {
    async openRentalLock(){
      let vm = this;
      if(vm.selected_lock && vm.selected_lock.id){
        vm.lockingInProcces = true;
        await rentalService.openOrCloseDoorById(vm, 'open', vm.selected_lock.id);
        vm.lockingInProcces = false;
        return;
      }else{
        toastr.error('Choose lock before opening or closing it!');
        return false;
      }
    },
    async closeRentalLock(){
      let vm = this;
      if(vm.selected_lock && vm.selected_lock.id){
        vm.lockingInProcces = true;
        await rentalService.openOrCloseDoorById(vm, 'close', vm.selected_lock.id);
        vm.lockingInProcces = false;
        return ;
      }else{
        toastr.error('Choose lock before opening or closing it!');
        return false;
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/manage-locks/manage-locks.js